export * from "./_slider";
